
// import tools from './tools';

require('select2');
require('select2/dist/css/select2.css');

(() => {
    // if (tools.getMobileOperatingSystem() != 'unknown') {
    //     const originalSelect2 = $.fn.select2;
    //     $.fn.select2 = function (...args) {
    //         originalSelect2.apply(this, args);
    //         $(this).addClass('mobile');
    //     };
    // }
})();
